import { NgOptimizedImage } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { HighlightTextPipe } from '../../pipes/highlight-text.pipe';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';
import { PromoBlockConfiguration } from './models/promo-block.types';

@Component({
    selector: 'nw-promo-block',
    imports: [NgOptimizedImage, HighlightTextPipe, SanitizeHtmlPipe],
    templateUrl: './promo-block.component.html',
    styleUrl: './promo-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromoBlockComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() config!: PromoBlockConfiguration | string;

    public configuration!: PromoBlockConfiguration;
    @ViewChild('videoEl') videoEl!: ElementRef<HTMLVideoElement>;
    private intervalId!: unknown;

    public ngAfterViewInit(): void {
        this.forceAutoplay();
    }

    public ngOnDestroy(): void {
        clearInterval(this.intervalId as number);
    }

    private forceAutoplay(): void {
        if (this.configuration?.media?.type !== 'video') return;

        const MAX_ATTEMPTS = 10;
        let attempts = 0;

        this.intervalId = setInterval(() => {
            const video = this.videoEl?.nativeElement;

            if (!video && attempts < MAX_ATTEMPTS) {
                attempts++;
                return;
            }
            if (!video || attempts >= MAX_ATTEMPTS) {
                clearInterval(this.intervalId as number);
                return;
            }

            const promise = video.play();
            if (promise !== undefined) {
                promise
                    .then(() => {})
                    .catch(() => {
                        video.muted = true;
                        video.play();
                    });
            }
            attempts++;
        }, 1000);
    }

    public ngOnChanges({ config }: SimpleChanges): void {
        if (config?.currentValue) {
            this.configuration =
                typeof this.config === 'string'
                    ? JSON.parse(this.config)
                    : { ...this.config };
        }
    }
}
